import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getClusterResources,
  getGroupResources,
  getResourceType,
  getRoleOverview,
  getRoles,
  getAclOperationOptions,
} from '@/services/kafkaPermissionsService';

const initialState = {
  overview: {},
  roleOptions: [],
  loading: false,
  resourceTypeOptions: [],
  resourceOptions: [],
  groupOptions: [],
  aclOperationOptions: [],
};

// 角色下拉
export const fetchRoleOptions = createAsyncThunk(
  'kafkaPermissions/fetchRoleOptions',
  async (params) => {
    const response = await getRoles(params);
    return response.data;
  },
);

export const fetchRoleOverview = createAsyncThunk(
  'kafkaPermissions/fetchRoleOverview',
  async (params) => {
    const response = await getRoleOverview(params);
    return response.data;
  },
);

export const fetchResourceOptions = createAsyncThunk(
  'kafkaPermissions/fetchResourceOptions',
  async (params) => {
    const response = await getClusterResources(params);
    return response.data;
  },
);

export const fetchGroupOptions = createAsyncThunk(
  'kafkaPermissions/fetchGroupOptions',
  async (params) => {
    const response = await getGroupResources(params);
    return response.data;
  },
);

export const fetchAclOperationOptions = createAsyncThunk(
  'kafkaPermissions/fetchAclOperationOptions',
  async (params) => {
    const response = await getAclOperationOptions(params);
    return response.data;
  },
);

export const fetchResourceTypeOptions = createAsyncThunk(
  'kafkaPermissions/fetchResourceTypeOptions',
  async () => {
    const response = await getResourceType();
    return response.data;
  },
);

export const kafkaPermissionsSlice = createSlice({
  name: 'kafkaPermissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoleOverview.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoleOverview.fulfilled, (state, action) => {
        state.overview = action.payload;
        state.loading = false;
      })
      .addCase(fetchRoleOverview.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchResourceTypeOptions.fulfilled, (state, action) => {
        state.resourceTypeOptions = action.payload.map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchAclOperationOptions.fulfilled, (state, action) => {
        state.aclOperationOptions = action.payload.map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchRoleOptions.fulfilled, (state, action) => {
        state.roleOptions = (action.payload || []).map((item) => ({
          label: item.kafkaUser,
          value: item.kafkaUser,
        }));
      })
      .addCase(fetchResourceOptions.fulfilled, (state, action) => {
        state.resourceOptions = action.payload.map((item) => ({
          label: item,
          value: item,
        }));
      })
      .addCase(fetchGroupOptions.fulfilled, (state, action) => {
        state.groupOptions = action.payload.map((item) => ({
          label: item,
          value: item,
        }));
      });
  },
});

export default kafkaPermissionsSlice.reducer;
